/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Markdown from 'react-remarkable';
import styled, { css } from 'styled-components';
import { palette, breakpoints } from '../../constants/styles';

const e = React.createElement;

const StyledTitle = styled(({ tag, children, ...props }) => e(tag, props, children))`
  display: ${({ display }) => display};
  font-family: 'Poppins';
  font-weight: 700;
  margin-top: 0px;
  margin-bottom: 0px;

  ${({ level }) => {
    switch (level) {
      case 1: return css`
        font-size: 3.052rem;
        line-height: 1;
        margin: 0.6rem 0;
      `;
      case 2: return css`
        font-size: 2.141rem;
        line-height: 1.2;
        margin: 1rem 0;
      `;
      case 3: return css`
        font-size: 1.753rem;
      `;
      case 4: return css`
        font-size: 1.563rem;
        margin: 1rem 0;
      `;
      case 5: return css`
        font-size: 1.25rem;
      `;
      case 6: return css`
        font-size: 1rem;
      `;
      default: return css`
        font-size: 16px;
      `;
    }
  }}

  color: ${({ color }) => color};
  font-size: ${({ size }) => (Number.isInteger(size) ? `${size}px` : size)};
  font-weight: ${({ bold, medium, light }) => (bold && '700') || (medium && '500') || (light && '300')};
  word-wrap: ${({ breakable }) => (breakable && 'break-word')};
  letter-spacing: ${({ spacing }) => spacing};
  line-height: ${({ lineheight }) =>
    (Number.isInteger(lineheight) ? `${lineheight}px` : lineheight)};
  text-align: ${({ align }) => align};

  ${({ styles }) => styles}
`;

StyledTitle.propTypes = {
  tag: PropTypes.string,
};

StyledTitle.defaultProps = {
  tag: 'span',
};

const Title = ({
  children,
  level,
  size,
  color,
  bold,
  breakable,
  medium,
  light,
  spacing,
  align,
  styles,
  className,
  display,
  style,
}) => (<StyledTitle
    tag={`h${level}`}
    level={level}
    size={size}
    color={color}
    bold={bold ? 1 : 0}
    display={display}
    breakable={breakable ? 1 : 0}
    medium={medium ? 1 : 0}
    light={light ? 1 : 0}
    spacing={spacing}
    align={align}
    styles={styles}
    className={className}
    style={style}
  >
    {children}
  </StyledTitle>
);

Title.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]),
  level: PropTypes.number,
  size: PropTypes.string,
  color: PropTypes.string,
  bold: PropTypes.bool,
  breakable: PropTypes.bool,
  medium: PropTypes.bool,
  light: PropTypes.bool,
  spacing: PropTypes.string,
  align: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
  inline: PropTypes.bool,
};

Title.defaultProps = {
  children: null,
  level: 0,
  size: '',
  color: palette.titlesColors,
  bold: false,
  breakable: false,
  medium: false,
  light: false,
  spacing: '',
  align: '',
  style: {},
  className: '',
  display: 'block',
};

export default Title;